import type { PermissionsItem } from '@/modules/api/codegen';
import { useHasSharingPermissions } from '@/modules/settings/hooks';

import type { Share } from '../types';
import { isPublicSharingActive } from '../utilities';

interface UseIsSharingIndicatorVisibleProps {
    share?: Share | null;
    userPermissions: PermissionsItem[];
}

export const useSharingIndicatorVisibility = () => {
    const { getHasSharingPermissions } = useHasSharingPermissions();

    const getSharingIndicatorVisibility = ({ share, userPermissions }: UseIsSharingIndicatorVisibleProps) => {
        const publicSharingActive = isPublicSharingActive(share);
        const hasSharingPermissions = getHasSharingPermissions(userPermissions);

        const shouldShowSharingIndicator = publicSharingActive && hasSharingPermissions;

        return shouldShowSharingIndicator;
    };

    return { getSharingIndicatorVisibility };
};
